<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
import * as Address from '@/services/rest-api/lib/delivery/address'

export default {
  props: {
    value: {},
    fullObject: {},
    id: {},
  },
  emits: ['input', 'update:fullObject'],
  data() {
    return {
    }
  },
  computed: {
    field() {
      return {
        name: 'start_address_id',
        type: 'value-help-v2',
        label: this.$t('routeOptimization.fields.originAddress'),
        placeholder: `${this.$t('global.form.select')} ${this.$t('routeOptimization.fields.originAddress')}`,
        validation: 'required',
        trackBy: 'id',
        displayedBy: 'name',
        help: true,
        tooltip: this.$t('routeOptimization.tooltip.selectAddress'),
        listGetter: Address.get(),
        tableFields: [
          {
            label: this.$t('routeOptimization.fields.addressName'),
            key: 'name',
          },
          {
            label: this.$t('routeOptimization.fields.addressDetail'),
            key: 'full_name',
          },
        ],
      }
    },
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return typeof this.value === 'string' ? Number(this.value) : this.value
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
